import queryStringBuilder from '../../utils/queryStringBuilder';

const API_URL = process.env.API_URL;
const jwt = () => localStorage.getItem('jwt');

export const getChannels = (options = {}) =>
    fetch(`${API_URL}/channel${options.isSimple ? '?is_simple=1' : ''}`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })

export const getChannel = (channelId) =>
    fetch(`${API_URL}/channel/${channelId}`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })

export const createChannel = (channel) =>
    fetch(`${API_URL}/channel`, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        },
        body: JSON.stringify(channel)
    })

export const updateChannel = (channelId, channel) =>
    fetch(`${API_URL}/channel/${channelId}`, {
        method: 'PUT',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        },
        body: JSON.stringify(channel)
    })

export const deleteChannels = (channelIds) =>
    fetch(`${API_URL}/channel/batch-delete`, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        },
        body: JSON.stringify({ channelIds })
    })

export const getChannelAdLinks = (channelId) =>
    fetch(`${API_URL}/channel/${channelId}/ad-link`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })

export const getChannelAdLink = (channelId, adLinkId) =>
    fetch(`${API_URL}/channel/${channelId}/ad-link/${adLinkId}`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })

export const createChannelAdLink = (channelId, adLink) =>
    fetch(`${API_URL}/channel/${channelId}/ad-link`, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        },
        body: JSON.stringify(adLink)
    })

export const updateChannelAdLink = (channelId, adLinkId, adLink) =>
    fetch(`${API_URL}/channel/${channelId}/ad-link/${adLinkId}`, {
        method: 'PUT',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        },
        body: JSON.stringify(adLink)
    })

export const deleteChannelAdLinks = (channelId, adLinkIds) =>
    fetch(`${API_URL}/channel/${channelId}/ad-link/batch-delete`, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        },
        body: JSON.stringify({ adLinkIds })
    })

export const getChannelOverallDistribution = (queries) =>
    fetch(`${API_URL}/channel/overall-distribution?${queryStringBuilder(queries)}`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })

export const getChannelLeadDistribution = (queries) =>
    fetch(`${API_URL}/channel/lead-distribution?${queryStringBuilder(queries)}`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })

export const getChannelEnrollmentDistribution = (queries) =>
    fetch(`${API_URL}/channel/enrollment-distribution?${queryStringBuilder(queries)}`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })

export const getChannelSources = () =>
    fetch(`${API_URL}/channel-source`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })

export const deleteChannelSource = (channelSourceId) =>
    fetch(`${API_URL}/channel-source/${channelSourceId}`, {
        method: 'DELETE',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        },
    })

export const getChannelTypes = () =>
    fetch(`${API_URL}/channel-type`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })

export const deleteChannelType = (channelTypeId) =>
    fetch(`${API_URL}/channel-type/${channelTypeId}`, {
        method: 'DELETE',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        },
    })


// WEBPACK FOOTER //
// ./src/services/api/channel.js